import { Lock } from 'lucide-react';

/** Commentaire privé d'un résumé de séance (21/10/2026) : lu par les moniteurs seulement, jamais par l'élève. */
export function PrivateNote({ text }: { text?: string | null }) {
  if (!text) return null;
  return (
    <p className="flex gap-2 rounded-xl bg-surface-light px-3 py-2 text-sm text-body">
      <Lock size={14} className="mt-0.5 shrink-0 text-secondary" aria-hidden />
      <span>
        <span className="font-semibold text-heading">Commentaire privé (moniteurs seulement) :</span> {text}
      </span>
    </p>
  );
}
